module.exports = __webpack_public_path__ + "static/img/enterpriseBig4.06b6a900.png";